document.addEventListener('DOMContentLoaded', function () {
	if (document.querySelector('#contactMapId')) {
		var map;
		var corner1 = [56.000, 12.512];
		var corner2 = [47.729, 25.512];
		var customIcon = L.icon({
			iconUrl: `${fh_config.template_uri}/dist/images/marker-icon.png`,
			iconSize: [25, 41],
			iconAnchor: [12, 41],
			popupAnchor: [0, -41]
		});

		var pos = {
			warszawa: {
				marker: {},
				address: "ul. Grójecka 17, 02-021",
				normal: [52.222418, 20.987265],
				centered: [52.222655, 20.987277],
			},
			katowice: {
				marker: {},
				address: "ul. Al. Korfantego 138A, 40-028",
				normal: [50.28001, 19.02044],
				centered: [50.28001, 19.02044]
			}
		};

		function loadMap() {
			map = L.map('contactMapId', {
				zoomAnimation: true,
				dragging: true, tap: false
			}).setView(pos.warszawa.centered, 18);

			L.tileLayer("https://mapa-lokomotyw.pkpcargo.com/tiles/transport/{z}/{x}/{y}.png", {
				maxZoom: 18,
				minZoom: 8,
				attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap contributors</a>',
			}).addTo(map);

			L.control.scale().addTo(map);
			addMarkersToMap();
			map.setMaxBounds([corner1, corner2]);
		}

		function addMarkersToMap() {
			pos["warszawa"].marker = createMarker("warszawa");
			pos["katowice"].marker = createMarker("katowice");
		}

		function createMarker(city) {
			return L.marker(pos[city].normal, { icon: customIcon })
			.bindPopup(pos[city].address)
			.on('click', function (e) {
				map.flyTo(pos[city].centered, 18);
				setActiveClass(city);
				this.openPopup();
			})
			.addTo(map);
		}

		function setPositionToCity(city) {
			setActiveClass(city);
			map.flyTo(pos[city].centered, 18);
			pos[city].marker.openPopup();
		}

		function setActiveClass(city) {
			var elements = document.getElementsByClassName("switch-item");
			for (const element of elements) {
				element.classList.remove("active");
			}
			document.getElementById(city).classList.add("active");
		}

		document.getElementById('warszawa').addEventListener('click', function () {
			setPositionToCity('warszawa');
		});
		document.getElementById('katowice').addEventListener('click', function () {
			setPositionToCity('katowice');
		});

		loadMap();
		setPositionToCity("warszawa");
	}
});